module.exports = __webpack_public_path__ + "img/deco-meeting.8e5c0d89.svg";